import router from '@/router'
import { useFormStore } from '@/stores/form'

export default function () {
  const formStore = useFormStore()
  const res = {
    selectIdentificater: formStore.form.values.selectIdentificater,
    isUsingCardReader: formStore.form.values.isUsingCardReader,
    notRequiredSponsorEIDA: formStore.extraMap.notRequiredSponsorEIDA,
    hideSponsorInformation: formStore.extraMap.hideSponsorInformation
  }
  return res
}
